import React from 'react'
import './CelebrationOverlay.css'

const CONFETTI_COLORS = ['#0081A7', '#8EA604', '#FE9C5D', '#A71D31', '#FFC107', '#4CAF50']

const CelebrationOverlay = ({ showConfetti, showXpPop, xpAmount = 20 }) => {
  const pieces = React.useMemo(() => {
    return Array.from({ length: 40 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 1.5}s`,
      color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
      rotation: Math.random() * 360,
      size: 6 + Math.random() * 8,
      isCircle: Math.random() > 0.5
    }))
  }, [showConfetti]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {showConfetti && (
        <div className="celebration-overlay-confetti">
          {pieces.map(p => (
            <div
              key={p.id}
              className="celebration-confetti-piece"
              style={{
                left: p.left,
                animationDelay: p.delay,
                backgroundColor: p.color,
                borderRadius: p.isCircle ? '50%' : '2px',
                width: `${p.size}px`,
                height: `${p.size}px`,
                transform: `rotate(${p.rotation}deg)`
              }}
            />
          ))}
        </div>
      )}
      {showXpPop && (
        <div className="celebration-xp-pop">+{xpAmount} XP</div>
      )}
    </>
  )
}

export default CelebrationOverlay
